import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// --- TEAM IMAGE IMPORTS ---
import davidCookman from '../assets/team/david-cookman.jpg';
import lauraSteele from '../assets/team/laura-steele.jpg';
import fawadAli from '../assets/team/fawad-ali.jpg';
import chrisSenior from '../assets/team/chris-senior.jpg';
import jahangirArif from '../assets/team/jahangir-arif.jpg';

// --- IMAGE IMPORTS ---
import mainImg from '../assets/images/about-us.png';
import bannerImg from '../assets/images/banner.png';

// --- ACCREDITATION LOGO IMPORTS ---
import acclaimLogo from '../assets/accreditationlogos/Acclaim-accreditation-logo.png';
import acsLogo from '../assets/accreditationlogos/ACS-logo.png';
import armedForcesLogo from '../assets/accreditationlogos/Armed-Forces-Covenant-logo.png';
import bicscLogo from '../assets/accreditationlogos/BICSc-logo.png';
import constructionLineLogo from '../assets/accreditationlogos/Construction-line-gold-member-logo.png';
import disabilityConfidentLogo from '../assets/accreditationlogos/Disability-confident-logo.png';
import investorsInPeopleLogo from '../assets/accreditationlogos/Investors-in-people-logo.png';
import iso9001Logo from '../assets/accreditationlogos/ISO-9001-logo.png';
import iso14001Logo from '../assets/accreditationlogos/ISO-14001-logo.png';
import iso45001Logo from '../assets/accreditationlogos/ISO-45001-logo.png';
import nasduLogo from '../assets/accreditationlogos/NASDU-logo.png';
import risqsLogo from '../assets/accreditationlogos/RISQS-logo.png';
import safeContractorLogo from '../assets/accreditationlogos/Safe-contractor-logo.png';
// pacesetterLogo removed

const About = () => {
  // Pacesetter removed from array
  const accreditationLogos = [
    { src: acclaimLogo, alt: "Acclaim Accreditation" },
    { src: acsLogo, alt: "ACS" },
    { src: armedForcesLogo, alt: "Armed Forces Covenant" },
    { src: bicscLogo, alt: "BICSc" },
    { src: constructionLineLogo, alt: "Construction Line Gold" },
    { src: disabilityConfidentLogo, alt: "Disability Confident" },
    { src: investorsInPeopleLogo, alt: "Investors in People" },
    { src: iso9001Logo, alt: "ISO 9001" },
    { src: iso14001Logo, alt: "ISO 14001" },
    { src: iso45001Logo, alt: "ISO 45001" },
    { src: nasduLogo, alt: "NASDU" },
    { src: risqsLogo, alt: "RISQS" },
    { src: safeContractorLogo, alt: "Safe Contractor" }
  ];

  // Logic for the interactive logo slider
  const [startIndex, setStartIndex] = useState(0);
  const logosToShow = 5; // How many logos fit on the screen at once

  const handleNextLogos = () => {
    setStartIndex((prevIndex) => 
      (prevIndex + logosToShow) >= accreditationLogos.length ? 0 : prevIndex + logosToShow
    );
  };

  const handlePrevLogos = () => {
    setStartIndex((prevIndex) => 
      (prevIndex - logosToShow) < 0 ? Math.max(0, accreditationLogos.length - logosToShow) : prevIndex - logosToShow
    );
  };

  // Slice the array to only show the current 5
  const visibleLogos = accreditationLogos.slice(startIndex, startIndex + logosToShow);

  return (
    <div className="about-page">
      
      {/* INJECTED STYLES FOR THE NEW NAVY VALUE CARDS, 5-COLUMN TEAM GRID, & MOBILE FIXES */}
      <style>
        {`
          /* --- REMOVE GLOBAL HERO ARROW JUST FOR ABOUT PAGE --- */
          .about-hero::after {
            display: none !important;
          }

          .value-navy-card {
            background: var(--color-primary-navy);
            border-radius: 16px;
            padding: 3rem 2.5rem;
            position: relative;
            box-shadow: 0 10px 30px rgba(0,0,0,0.08);
            display: flex;
            flex-direction: column;
            height: 100%;
            transition: none !important; /* Force disable global transitions */
          }

          /* --- DISABLE HOVER ON VALUE NAVY CARDS --- */
          .value-navy-card:hover {
            transform: none !important;
            box-shadow: 0 10px 30px rgba(0,0,0,0.08) !important;
          }

          /* --- DISABLE HOVER ON STATS CARDS --- */
          .stat-card-no-hover:hover {
            transform: none !important;
            border-bottom-color: var(--color-secondary-light) !important;
            box-shadow: 0 10px 30px rgba(0,0,0,0.05) !important;
          }
          .stat-card-no-hover:hover .stat-label {
            color: var(--color-secondary-grey) !important;
          }
          .stat-card-no-hover:hover::before {
            background-color: var(--color-secondary-light) !important;
            box-shadow: none !important;
          }

          /* Force Team Grid to 5 columns for desktop */
          .team-grid-5 {
             display: grid;
             grid-template-columns: repeat(5, 1fr);
             gap: 2rem;
          }

          /* --- PREMIUM MOBILE RESPONSIVE FIXES --- */
          @media (max-width: 1200px) {
            .team-grid-5 { grid-template-columns: repeat(3, 1fr); gap: 3rem; }
          }
          @media (max-width: 1024px) {
            .values-custom-grid { grid-template-columns: repeat(2, 1fr) !important; }
          }
          @media (max-width: 768px) {
            /* Hero adjustments to prevent overlap with header */
            .about-hero { padding: 13rem 1.5rem 5rem 1.5rem !important; }
            .about-hero h1 { font-size: 2.5rem !important; line-height: 1.2 !important; }
            .about-hero p.subtitle { font-size: 1.1rem !important; }

            /* Enforce container boundaries */
            .container { padding-left: 1.5rem !important; padding-right: 1.5rem !important; }

            .values-custom-grid { grid-template-columns: 1fr !important; }
            .mission-heading { font-size: 2rem !important; }
            .team-grid-5 { grid-template-columns: repeat(2, 1fr); gap: 2rem; }

            /* FIX: Explicitly target top and bottom to avoid wiping out left/right container padding */
            .about-overview { padding-top: 4rem !important; padding-bottom: 4rem !important; }
            .services-header-split { gap: 2rem !important; }

            /* Fix CTA layout overlapping screen edges */
            .sleek-cta-banner { flex-direction: column; text-align: center; padding: 3rem 1.5rem !important; }
            .sleek-cta-text { min-width: 100% !important; text-align: center !important; }
          }
          @media (max-width: 500px) {
            .team-grid-5 { grid-template-columns: 1fr; gap: 3rem; }
            .member-photo-oval { width: 160px; height: 220px; }
          }
        `}
      </style>

      {/* 1. HERO SECTION */}
      <section className="about-hero">
        <div className="container text-center">
          <h1>About Us</h1>
          <p className="subtitle">
            Protecting People. Securing Assets. Delivering Confidence.
          </p>
        </div>
      </section>

      {/* 2. DETAILED COMPANY OVERVIEW */}
      <section className="about-overview container" style={{ paddingTop: '8rem', paddingBottom: '4rem' }}>
        <div className="services-header-split">
          <div className="header-left-col">
            <h2>Intelligence-Led Risk Mitigation & Trusted Security</h2>
            <p style={{ color: 'var(--color-primary-navy)', fontWeight: '600', fontSize: 'var(--fs-h4)', lineHeight: 'var(--lh-body)' }}>
              Nightmark Protective Services exists to safeguard people, property and assets through reliable and professional security management across the UK.
            </p>
            <p style={{ fontSize: 'var(--fs-body)', lineHeight: 'var(--lh-body)' }}>
              Our trained and licensed professionals deliver nationally consistent security services, working in partnership with the organisations we support to develop solutions tailored to their operational requirements.
            </p>
            <p style={{ fontSize: 'var(--fs-body)', lineHeight: 'var(--lh-body)' }}>
              Through proactive risk awareness, disciplined site management and clear communication, we help our customers maintain safe, controlled environments where people and businesses can operate with confidence.
            </p>
          </div>
          
          <div className="header-right-col" style={{ display: 'flex', alignItems: 'center' }}>
            <div 
              className="card-image-box" 
              style={{ 
                backgroundImage: `url(${mainImg})`, 
                backgroundSize: 'cover', 
                backgroundPosition: 'center', 
                width: '100%', 
                minHeight: '400px', 
                borderRadius: '12px', 
                marginBottom: '1.5rem', 
                position: 'relative',
                boxShadow: '0 10px 30px rgba(0,0,0,0.15)'
              }}
            >
            </div>
          </div>
        </div>
      </section>

      {/* 3. UPDATED TEAM SECTION (LEFT-ALIGNED HEADER) */}
      <section className="team-section container" style={{ paddingTop: '6rem', paddingBottom: '6rem' }}>
        <div className="team-section-header" style={{ marginBottom: '4rem', textAlign: 'center' }}>
          <h2>Meet The Leadership Team</h2>
          <p style={{ maxWidth: '700px', margin: '0 auto', fontSize: 'var(--fs-body)', lineHeight: 'var(--lh-body)' }}>
            Our operational excellence is driven by a team of highly experienced security professionals dedicated to securing your assets.
          </p>
        </div>
        
        <div className="team-grid-5" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '3rem' }}>
          
          {/* Member 1: David Cookman */}
          <div className="team-member text-center">
            <div className="member-photo-container">
              <div className="member-photo-oval" style={{ backgroundImage: `url(${davidCookman})`, backgroundSize: 'cover', backgroundPosition: 'top center' }}></div>
            </div>
            <h3>David<br />Cookman</h3>
            <p style={{ fontWeight: '600', color: 'var(--color-primary-navy)', fontSize: 'var(--fs-body)' }}>Group CEO</p>
            <div className="team-socials">
              <a href="https://www.linkedin.com/in/david-cookman-senior-fm-and-security-leader/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">in</a>
            </div>
          </div>

          {/* Member 2: Laura Steele */}
          <div className="team-member text-center">
            <div className="member-photo-container">
              <div className="member-photo-oval" style={{ backgroundImage: `url(${lauraSteele})`, backgroundSize: 'cover', backgroundPosition: 'top center' }}></div>
            </div>
            <h3>Laura<br />Steele</h3>
            <p style={{ fontWeight: '600', color: 'var(--color-primary-navy)', fontSize: 'var(--fs-body)' }}>Group Business Director</p>
            <div className="team-socials">
              <a href="https://www.linkedin.com/in/laura-steele-7134026b/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">in</a>
            </div>
          </div>

          {/* Member 3: Fawad Ali */}
          <div className="team-member text-center">
            <div className="member-photo-container">
              <div className="member-photo-oval" style={{ backgroundImage: `url(${fawadAli})`, backgroundSize: 'cover', backgroundPosition: 'top center' }}></div>
            </div>
            <h3>Fawad<br />Ali</h3>
            <p style={{ fontWeight: '600', color: 'var(--color-primary-navy)', fontSize: 'var(--fs-body)' }}>Group Finance Director</p>
            <div className="team-socials">
              <a href="https://www.linkedin.com/in/fawad-a-ba876314a/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">in</a>
            </div>
          </div>

          {/* Member 4: Chris Senior */}
          <div className="team-member text-center">
            <div className="member-photo-container">
              <div className="member-photo-oval" style={{ backgroundImage: `url(${chrisSenior})`, backgroundSize: 'cover', backgroundPosition: 'top center' }}></div>
            </div>
            <h3>Chris<br />Senior</h3>
            <p style={{ fontWeight: '600', color: 'var(--color-primary-navy)', fontSize: 'var(--fs-body)' }}>Managing Director</p>
            <div className="team-socials">
              <a href="https://www.linkedin.com/in/chris-senior01/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">in</a>
            </div>
          </div>

        </div>
      </section>

      {/* 4. NEW MISSION & CORE VALUES SECTION */}
      <section className="mission-values-section" style={{ padding: '6rem 0 8rem 0', backgroundColor: 'var(--color-white)' }}>
        <div className="container">
          
          {/* High-Impact Mission Statement */}
          <div style={{ textAlign: 'center', maxWidth: '900px', margin: '0 auto 6rem auto' }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '1rem', marginBottom: '2rem' }}>
              <div style={{ height: '2px', width: '40px', backgroundColor: 'var(--color-primary-navy)' }}></div>
              <span style={{ color: 'var(--color-primary-navy)', fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase', fontSize: 'var(--fs-small)' }}>Our Mission</span>
              <div style={{ height: '2px', width: '40px', backgroundColor: 'var(--color-primary-navy)' }}></div>
            </div>
            <h2 className="mission-heading" style={{ fontSize: '2.8rem', lineHeight: '1.3', color: 'var(--color-primary-dark)', letterSpacing: '-0.5px' }}>
              To protect people, property and operations through professional security services delivered with consistency, accountability and trust.
            </h2>
          </div>

          {/* Solid Navy Values Grid */}
          <div className="values-custom-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '2rem' }}>
            
            {/* Value 1 */}
            <div className="value-navy-card">
               <h3 style={{ color: 'var(--color-white)', fontSize: 'var(--fs-h3)', marginBottom: '1rem' }}>Reliability</h3>
               <p style={{ margin: 0, fontSize: 'var(--fs-body)', color: 'var(--color-secondary-light)', lineHeight: 'var(--lh-body)' }}>Consistent service. Dependable delivery. No surprises.</p>
            </div>

            {/* Value 2 */}
            <div className="value-navy-card">
               <h3 style={{ color: 'var(--color-white)', fontSize: 'var(--fs-h3)', marginBottom: '1rem' }}>Safety</h3>
               <p style={{ margin: 0, fontSize: 'var(--fs-body)', color: 'var(--color-secondary-light)', lineHeight: 'var(--lh-body)' }}>Protecting people, property and operations.</p>
            </div>

            {/* Value 3 */}
            <div className="value-navy-card">
               <h3 style={{ color: 'var(--color-white)', fontSize: 'var(--fs-h3)', marginBottom: '1rem' }}>Integrity</h3>
               <p style={{ margin: 0, fontSize: 'var(--fs-body)', color: 'var(--color-secondary-light)', lineHeight: 'var(--lh-body)' }}>Doing the right thing, even when nobody is watching.</p>
            </div>

            {/* Value 4 */}
            <div className="value-navy-card">
               <h3 style={{ color: 'var(--color-white)', fontSize: 'var(--fs-h3)', marginBottom: '1rem' }}>Partnership</h3>
               <p style={{ margin: 0, fontSize: 'var(--fs-body)', color: 'var(--color-secondary-light)', lineHeight: 'var(--lh-body)' }}>Working alongside our customers as an extension of their team.</p>
            </div>

          </div>
        </div>
      </section>

      {/* 5. COMMAND-CENTER STATS SECTION */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-header-text text-center">
            <h2>Security Solutions Built Around People</h2>
            <p className="stats-description" style={{ fontSize: 'var(--fs-body)', lineHeight: 'var(--lh-body)' }}>
              Providing trusted security services that protect what matters most whilst supporting the day-to-day needs of your organisation.
            </p>
          </div>

          <div className="stats-command-grid">
            <div className="stat-card-premium stat-card-no-hover">
              <span className="stat-number">ACS</span>
              <span className="stat-number">Approved</span>
            </div>
            
            <div className="stat-card-premium stat-card-no-hover">
              <span className="stat-number">24/7</span>
              <span className="stat-number">Helpdesk</span>
            </div>
            
            <div className="stat-card-premium stat-card-no-hover">
              <span className="stat-number">Strategic</span>
              <span className="stat-number">Consultants</span>
            </div>
            
            <div className="stat-card-premium stat-card-no-hover">
              <span className="stat-number">24/7</span>
              <span className="stat-number">SOC</span>
            </div>
            
            <div className="stat-card-premium stat-card-no-hover">
              <span className="stat-number">National</span>
              <span className="stat-number">Coverage</span>
            </div>
          </div>
        </div>
      </section>

      {/* 6. SLEEK FLOATING CTA BANNER */}
      <section className="cta-split-bg-wrapper">
        <div className="container">
          <div 
            className="sleek-cta-banner"
            style={{ 
              backgroundImage: `linear-gradient(to right, rgba(23, 44, 79, 0.95), rgba(23, 44, 79, 0.8)), url(${bannerImg})` 
            }}
          >
            
            <div className="sleek-cta-text">
              <h2>Professional Security Management</h2>
              <p style={{ fontSize: 'var(--fs-body)' }}>
                Discover how our intelligence-led approach can protect your operations.
              </p>
            </div>
            
            <div className="sleek-cta-action">
              <Link to="/contact" className="btn btn-pill" style={{ 
                backgroundColor: 'var(--color-white)', 
                color: 'var(--color-primary-navy)', 
                fontWeight: '700', 
                padding: '1rem 2.5rem', 
                fontSize: '0.95rem',
                boxShadow: '0 8px 20px rgba(0,0,0,0.1)'
              }}>
                Contact us
              </Link>
            </div>

          </div>
        </div>
      </section>

      {/* 7. ACCREDITATION CAROUSEL STRIP */}
      <section className="accreditation-carousel-section" style={{ backgroundColor: 'var(--color-white)', padding: '4rem 0', borderTop: '1px solid rgba(0,0,0,0.05)' }}>
        <div className="container">
          <div className="accreditation-interactive-wrapper" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '2rem' }}>
            
            <button 
              className="control-btn prev-btn" 
              onClick={handlePrevLogos} 
              aria-label="Previous Logos"
              style={{ backgroundColor: 'var(--color-light)', border: 'none', width: '40px', height: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'var(--color-primary-navy)', fontSize: '1.5rem', fontWeight: 'bold' }}
            >
              ‹
            </button>

            <div className="accreditation-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '2rem', width: '100%', alignItems: 'center', justifyItems: 'center' }}>
              {visibleLogos.map((logo, index) => (
                <div className="accreditation-slide-static" key={index}>
                  <img 
                    src={logo.src} 
                    alt={logo.alt} 
                    style={{ maxHeight: '70px', objectFit: 'contain' }}
                  />
                </div>
              ))}
            </div>

            <button 
              className="control-btn next-btn" 
              onClick={handleNextLogos} 
              aria-label="Next Logos"
              style={{ backgroundColor: 'var(--color-light)', border: 'none', width: '40px', height: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'var(--color-primary-navy)', fontSize: '1.5rem', fontWeight: 'bold' }}
            >
              ›
            </button>

          </div>
        </div>
      </section>

    </div>
  );
};

export default About;